import {
  PRODUCT_TYPE_INTEREST_SERVICE,
  INTEREST_SERVICING_LABEL,
  ROLL_UP_LABEL,
} from "lib/constants";
import productTypeResolver from "./productTypeResolver";

const productTypeLabelResolver = (value) => {
  const resolvedValue = productTypeResolver(value);

  if (resolvedValue === PRODUCT_TYPE_INTEREST_SERVICE) {
    return INTEREST_SERVICING_LABEL;
  } else {
    return ROLL_UP_LABEL;
  }
};

export default productTypeLabelResolver;
